import {
  SORT_OPTIONS,
  createCostcodeFilter,
  applyCostcodeSort,
} from './costcodeFilter';

export default function createCostcodeSortFilterController({
  storageKeyText,
  storageKeyActive,
  displayStateKey,
  getFetchedCodes,
  getArchivedLoaded,
  setState,
  onFetchArchived,
}) {
  const filter = createCostcodeFilter();
  let currentSort = JSON.parse(window.localStorage.getItem(storageKeyActive) ?? null);

  const applyFilters = () => {
    setState({
      [displayStateKey]: filter.applyFilters(),
      filterIsActive: filter.filterIsAtDefault(),
      activeFilters: filter.activeFilters,
    });
  };

  const sortName = (ascending) => {
    const { sortTitle, currentSort: newSort } = applyCostcodeSort({
      sortOptions: SORT_OPTIONS,
      fetchedCodes: getFetchedCodes(),
      filter,
      ascending,
      sortType: 'name',
      storageKeyText,
      storageKeyActive,
    });
    currentSort = newSort;
    setState({ sortActive: sortTitle });
    applyFilters();
  };

  const sortCode = (ascending) => {
    const { sortTitle, currentSort: newSort } = applyCostcodeSort({
      sortOptions: SORT_OPTIONS,
      fetchedCodes: getFetchedCodes(),
      filter,
      ascending,
      sortType: 'code',
      storageKeyText,
      storageKeyActive,
    });
    currentSort = newSort;
    setState({ sortActive: sortTitle });
    applyFilters();
  };

  const sortOptions = SORT_OPTIONS.map((opt, idx) => ({
    ...opt,
    action: () => {
      if (idx < 2) sortCode(idx === 0);
      else sortName(idx === 2);
    },
  }));

  const applyPersistedSort = () => {
    if (currentSort) {
      const [sortType, sortAscending] = currentSort;
      if (sortType === 'name') sortName(sortAscending);
      else sortCode(sortAscending);
      return;
    }
    sortCode(true);
  };

  const filterCostcodes = (checkedFilters, filterCategory) => {
    filter.setFilter(checkedFilters, filterCategory);

    if (filterCategory === 'active') {
      const wantsArchived = checkedFilters.includes(0);
      if (wantsArchived && !getArchivedLoaded()) {
        onFetchArchived();
        return;
      }
    }

    applyFilters();
  };

  const getInitialState = () => ({
    sortActive: window.localStorage.getItem(storageKeyText) || 'Code: Ascending',
    activeFilters: filter.activeFilters,
    filterIsActive: false,
  });

  const resetFilters = () => {
    filter.resetFilters();
    setState({
      activeFilters: filter.activeFilters,
      filterIsActive: false,
    });
  };

  return {
    filter,
    sortOptions,
    sortName,
    sortCode,
    applyFilters,
    filterCostcodes,
    applyPersistedSort,
    setFilterData: (data) => {
      filter.data = data;
    },
    getInitialState,
    resetFilters,
  };
}
